import { render, staticRenderFns } from "./guessLike.vue?vue&type=template&id=15bce4a8&scoped=true&"
import script from "./guessLike.vue?vue&type=script&lang=js&"
export * from "./guessLike.vue?vue&type=script&lang=js&"
import style0 from "./guessLike.vue?vue&type=style&index=0&id=15bce4a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bce4a8",
  null
  
)

export default component.exports